// import {
//   Button,
//   Form,
//   Input,
//   Table,
//   Select,
//   message,
//   Row,
//   Col,
//   Spin,
//   TreeSelect,
//   Modal,
// } from "antd";
// import { useEffect, useRef, useState } from "react";
// import {
//   fetchExecutionById,
//   postExecution,
//   putExecution,
// } from "../service/checklistExecution";
// import { InputNumber, Checkbox, Radio } from "antd";
// import { fetchProduct } from "../../Configuration/Product/Service/product";
// import { fetchBuildersByProductId } from "../../Configuration/ChecklistConfiguration/Service/checklistBuilder";
// import { useNavigate, useParams } from "react-router-dom";
// import { fetchCategoryForFilter } from "../../Configuration/Category/Service/category";
// import Webcam from "react-webcam";
// import { CameraOutlined } from "@ant-design/icons";

// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";

// // PDF export function
// const exportToPDF = (records, categories, fileName) => {
//   const doc = new jsPDF();

//   const maxImageHeight = 30; // height for each image
//   const padding = 2;

//   const tableData = records.map((r) => {
//     const category =
//       categories.find((cat) => cat.id === r.categoryId)?.category ||
//       r.categoryId;
//     const observation =
//       r.inputType === "OK_NOT_OK"
//         ? r.value === true
//           ? "OK"
//           : r.value === false
//           ? "NOT OK"
//           : "-"
//         : r.value?.toString() || "-";

//     return {
//       category,
//       description: r.description,
//       observation,
//       record: r, // keep full record here
//     };
//   });

//   // Compute dynamic row heights
//   const rowHeights = records.map((r) => {
//     const imgCount = r.liveImages?.length || 0;
//     const imgHeightTotal = imgCount * (maxImageHeight + padding);
//     const defaultRowHeight = 10;
//     return Math.max(defaultRowHeight, imgHeightTotal + padding);
//   });

//   autoTable(doc, {
//     head: [["Category", "Description", "Observation", "Live Images"]],
//     body: tableData.map((row) => [
//       row.category,
//       row.description,
//       row.observation,
//       "", // placeholder for images
//     ]),
//     styles: { cellPadding: 3, fontSize: 10, valign: "middle" },
//     columnStyles: { 3: { cellWidth: 60 } },
//     rowPageBreak: "avoid",

//     // 1) Calculate & set row height once per row before drawing
//     // Use didParseCell on column 0 to avoid setting row height multiple times
//     didParseCell: function (data) {
//       if (data.section === "body" && data.column.index === 0) {
//         const rec = tableData[data.row.index]?.record;
//         if (rec?.liveImages?.length) {
//           // total image block height (images stacked + padding between them)
//           const totalImgHeight =
//             rec.liveImages.length * (maxImageHeight + padding) - padding;
//           // add small extra padding so images do not touch borders
//           const desired = Math.max(data.row.height, totalImgHeight + 4);
//           data.row.height = desired;
//         }
//       }
//     },

//     // 2) Draw the images inside the Live Images column, vertically centered
//     didDrawCell: function (data) {
//       if (data.section === "body" && data.column.index === 3) {
//         const rec = tableData[data.row.index]?.record;
//         if (rec?.liveImages?.length) {
//           const totalImgHeight =
//             rec.liveImages.length * (maxImageHeight + padding) - padding;

//           // horizontal start (2pt padding from left)
//           const x = data.cell.x + 2;
//           // vertically center the image block inside the final row height
//           const startY =
//             data.cell.y + Math.max(2, (data.row.height - totalImgHeight) / 2);

//           let y = startY;
//           const imgWidth = Math.max(10, data.cell.width - 4); // ensure some width

//           rec.liveImages.forEach((imgBase64) => {
//             const imgSrc = imgBase64.startsWith("data:image")
//               ? imgBase64
//               : `data:image/png;base64,${imgBase64}`;

//             // draw image (width = cell width - padding, height = maxImageHeight)
//             doc.addImage(imgSrc, "PNG", x, y, imgWidth, maxImageHeight);
//             y += maxImageHeight + padding;
//           });
//         }
//       }
//     },
//   });

//   doc.save(fileName || "Checklist_Execution.pdf");
// };

// // Excel export
// const exportToExcel = async (records, categories, fileName) => {
//   const workbook = new ExcelJS.Workbook();
//   const sheet = workbook.addWorksheet("Checklist");

//   // Columns
//   sheet.columns = [
//     { header: "Category", key: "category", width: 25 },
//     { header: "Description", key: "description", width: 40 },
//     { header: "Observation", key: "observation", width: 15 },
//     { header: "Live Images", key: "images", width: 20 },
//   ];

//   // for (const record of records) {
//   //   const categoryName =
//   //     categories.find((c) => c.id === record.categoryId)?.category ||
//   //     record.categoryId;
//   //   const obs =
//   //     record.inputType === "OK_NOT_OK"
//   //       ? record.value === true
//   //         ? "OK"
//   //         : record.value === false
//   //         ? "NOT OK"
//   //         : "-"
//   //       : record.value?.toString() || "-";

//   //   const row = sheet.addRow([categoryName, record.description, obs, ""]);

//   //   // Add live images
//   //   if (record.liveImages?.length) {
//   //     let currentRow = row.number;

//   //     for (let i = 0; i < record.liveImages.length; i++) {
//   //       const img = record.liveImages[i];
//   //       const imageId = workbook.addImage({
//   //         base64: img.startsWith("data:image") ? img.split(",")[1] : img,
//   //         extension: "png",
//   //       });

//   //       sheet.addImage(imageId, {
//   //         tl: { col: 3, row: currentRow - 1 + i * 0.5 },
//   //         ext: { width: 100, height: 60 },
//   //       });
//   //     }

//   //     // Adjust row height
//   //     sheet.getRow(currentRow).height = 15 * record.liveImages.length; // approximate
//   //   }
//   // }

//   for (const record of records) {
//     const categoryName =
//       categories.find((c) => c.id === record.categoryId)?.category ||
//       record.categoryId;
//     const obs =
//       record.inputType === "OK_NOT_OK"
//         ? record.value === true
//           ? "OK"
//           : record.value === false
//           ? "NOT OK"
//           : "-"
//         : record.value?.toString() || "-";

//     // Add main row
//     const row = sheet.addRow([categoryName, record.description, obs, ""]);

//     // Add live images
//     if (record.liveImages?.length) {
//       let startRow = row.number;

//       for (let i = 0; i < record.liveImages.length; i++) {
//         const img = record.liveImages[i];
//         const imageId = workbook.addImage({
//           base64: img.startsWith("data:image") ? img.split(",")[1] : img,
//           extension: "png",
//         });

//         // Add image to row
//         // sheet.addImage(imageId, {
//         //   tl: { col: 3, row: startRow - 1 + i },
//         //   ext: { width: 100, height: 60 },
//         // });

//         const padding = 5; // in points
//         sheet.addImage(imageId, {
//           tl: { col: 3 + padding / 72, row: startRow - 1 + i + padding / 20 },
//           ext: { width: 100 - 2 * padding, height: 60 - 2 * padding },
//         });

//         // Adjust row height
//         sheet.getRow(startRow + i).height = 45; // approx height for image
//       }

//       // Optional: merge text cells for multiple image rows
//       if (record.liveImages.length > 1) {
//         sheet.mergeCells(
//           `A${row.number}:A${row.number + record.liveImages.length - 1}`
//         );
//         sheet.mergeCells(
//           `B${row.number}:B${row.number + record.liveImages.length - 1}`
//         );
//         sheet.mergeCells(
//           `C${row.number}:C${row.number + record.liveImages.length - 1}`
//         );
//       }
//     }
//   }

//   const buffer = await workbook.xlsx.writeBuffer();
//   saveAs(new Blob([buffer]), fileName || "Checklist_Execution.xlsx");
// };

// const ChecklistExecutionForm = ({ mode }) => {
//   const { id } = useParams();
//   const [form] = Form.useForm();
//   const [records, setRecords] = useState([]);
//   const [editData, setEditData] = useState(null);
//   const [categories, setCategories] = useState([]);
//   const [product, setProduct] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [executions, setExecutions] = useState([]);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const navigate = useNavigate();
//   const [isCamOpen, setIsCamOpen] = useState(false);
//   const [activeRecord, setActiveRecord] = useState(null);
//   const [previewImages, setPreviewImages] = useState([]);
//   const [isPreviewOpen, setIsPreviewOpen] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [selectedChecklist, setSelectedChecklist] = useState(null);
//   const [messageApi, contextHolder] = message.useMessage();

//   const webcamRef = useRef(null);

//   const capture = () => {
//     const imageSrc = webcamRef.current.getScreenshot();

//     if (activeRecord) {
//       if (!activeRecord.liveImages) {
//         activeRecord.liveImages = [];
//       }
//       activeRecord.liveImages.push(imageSrc);
//       setRecords([...records]);
//     }

//     // ✅ Just close modal (do not stop stream here)
//     setIsCamOpen(false);
//   };

//   const handleCancel = () => {
//     setIsModalOpen(false);
//     setSelectedImage(null);
//   };

//   const getChickListByProductId = async (productId, preselectChecklistId) => {
//     setSelectedProduct(productId);
//     setIsLoading(true);
//     try {
//       const res = await fetchBuildersByProductId(productId);
//       setExecutions(res.data);

//       // ✅ only after executions are ready
//       if (preselectChecklistId) {
//         setSelectedChecklist(preselectChecklistId);
//         const selected = res.data.find(
//           (exec) => exec.id === preselectChecklistId
//         );
//         if (selected) {
//           let normalized = (selected.records || []).map((r) => ({
//             ...r,
//             key: r.id || Date.now(),
//             liveImages: r.liveImages || [],
//             sampleImages: r.sampleImages || [],
//           }));
//           const mergeWithObservations = (templateRecords, observations) => {
//             return templateRecords.map((r) => {
//               const obs = observations.find((o) => o.recordId === r.id);
//               return {
//                 ...r,
//                 value: obs ? obs.value : r.value,
//                 liveImages: obs ? obs.liveImages || [] : r.liveImages || [],
//               };
//             });
//           };

//           if (editData?.observations) {
//             normalized = mergeWithObservations(
//               normalized,
//               editData.observations
//             );
//           }

//           setRecords(normalized);
//         }
//       } else {
//         setSelectedChecklist(null);
//       }
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const columns = [
//     {
//       title: "Category",
//       dataIndex: "categoryId",
//       key: "categoryId",
//       render: (_, record) =>
//         categories.find((cat) => cat.id === record.categoryId)?.category,
//     },
//     {
//       title: "Description",
//       dataIndex: "description",
//       key: "description",
//       render: (_, record) => record.description,
//     },
//     {
//       title: "Observation",
//       dataIndex: "response",
//       key: "response",
//       render: (_, record) => {
//         switch (record.inputType) {
//           case "OK_NOT_OK":
//             return (
//               <div style={{ display: "flex", gap: "1rem" }}>
//                 <Checkbox
//                   checked={record.value === true}
//                   disabled={mode === "view"}
//                   onChange={() => {
//                     record.value = true;
//                     setRecords([...records]);
//                   }}
//                 >
//                   OK
//                 </Checkbox>
//                 <Checkbox
//                   checked={record.value === false}
//                   disabled={mode === "view"}
//                   onChange={() => {
//                     record.value = false;
//                     setRecords([...records]);
//                   }}
//                 >
//                   NOT OK
//                 </Checkbox>
//               </div>
//             );

//           case "OPTIONS":
//             return (
//               <Radio.Group
//                 value={record.value}
//                 disabled={mode === "view"}
//                 onChange={(e) => {
//                   record.value = e.target.value;
//                   setRecords([...records]);
//                 }}
//               >
//                 {record.options?.map((opt, idx) => (
//                   <Radio key={idx} value={opt}>
//                     {opt}
//                   </Radio>
//                 ))}
//               </Radio.Group>
//             );

//           case "STRING":
//             return (
//               <Input
//                 // defaultValue={record.value}
//                 value={record.value || ""}
//                 disabled={mode === "view"}
//                 onChange={(e) => {
//                   record.value = e.target.value;
//                   setRecords([...records]);
//                 }}
//               />
//             );

//           case "DOUBLE":
//             return (
//               <InputNumber
//                 style={{ width: "100%" }}
//                 value={record.value}
//                 disabled={mode === "view"}
//                 onChange={(val) => {
//                   record.value = val;
//                   setRecords([...records]);
//                 }}
//               />
//             );

//           default:
//             return <span>-</span>;
//         }
//       },
//     },
//     {
//       title: "Sample Images",
//       dataIndex: "sampleImages",
//       key: "sampleImages",
//       render: (_, record) => (
//         <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
//           {record.sampleImages?.map((img, idx) => {
//             const src =
//               typeof img === "string"
//                 ? `data:image/png;base64,${img}` // raw base64 string
//                 : img.url; // normalized object
//             return (
//               <img
//                 key={idx}
//                 src={src}
//                 alt={`sample-${idx}`}
//                 style={{
//                   width: 100,
//                   height: 100,
//                   objectFit: "cover",
//                   borderRadius: 4,
//                 }}
//                 onClick={() => {
//                   setIsModalOpen(true);
//                   setSelectedImage(src);
//                 }}
//               />
//             );
//           })}

//           {record.sampleImages.length === 0 && "No image available"}
//         </div>
//       ),
//     },
//     {
//       title: "Live Images",
//       dataIndex: "liveImages",
//       key: "liveImages",
//       render: (_, record) => (
//         <div>
//           <div
//             style={{
//               display: "flex",
//               gap: "8px",
//               marginTop: 8,
//               flexWrap: "wrap",
//             }}
//           >
//             {record.liveImages?.map((img, idx) => (
//               <div
//                 key={idx}
//                 style={{ position: "relative", display: "inline-block" }}
//               >
//                 <img
//                   src={img}
//                   alt="captured"
//                   style={{
//                     width: 100,
//                     height: 100,
//                     objectFit: "cover",
//                     borderRadius: 4,
//                     cursor: "pointer",
//                   }}
//                   onClick={() => {
//                     // preview image in modal
//                     setPreviewImages([img]);
//                     setIsPreviewOpen(true);
//                   }}
//                 />

//                 {mode === "view" || (
//                   <Button
//                     type="text"
//                     size="small"
//                     danger
//                     style={{
//                       position: "absolute",
//                       top: -6,
//                       right: -6,
//                       borderRadius: "50%",
//                       background: "white",
//                       border: "1px solid #ccc",
//                       lineHeight: "12px",
//                       height: 18,
//                       width: 18,
//                       padding: 0,
//                       fontSize: 10,
//                     }}
//                     onClick={() => {
//                       record.liveImages = record.liveImages.filter(
//                         (_, i) => i !== idx
//                       );
//                       setRecords([...records]);
//                     }}
//                   >
//                     ✕
//                   </Button>
//                 )}
//               </div>
//             ))}
//             {record.liveImages.length === 0 && "No image available"}
//           </div>
//           {mode === "view" || (
//             <Button
//               size="small"
//               onClick={() => {
//                 setActiveRecord(record);
//                 setIsCamOpen(true);
//               }}
//             >
//               <CameraOutlined />
//             </Button>
//           )}
//         </div>
//       ),
//     },
//   ];

//   const onFinish = (values) => {
//     const payload = {
//       serialNumber: values.serialNumber, // unique id
//       productId: selectedProduct,
//       checklistId: selectedChecklist,
//       observations: records.map((r) => ({
//         recordId: r.id || null, // optional: link to checklist record
//         inputType: r.inputType, // send type for backend parsing
//         value: r.value, // actual observation
//         liveImages: r.liveImages || [],
//       })),
//     };

//     saveData(payload);
//   };

//   const saveData = async (data) => {
//     setIsLoading(true);
//     try {
//       let res;
//       if (editData) res = await putExecution(data, editData.id);
//       else res = await postExecution(data);
//       messageApi.open({
//         type: "success",
//         content: `Execution ${editData ? "updated" : "added"} successfully`,
//       });

//       if (editData) {
//         setTimeout(() => {
//           navigate({ pathname: "/check-list" });
//         }, 2000);
//       } else {
//         form.resetFields(["serialNumber"]);
//         setRecords((prev) =>
//           prev.map((r) => ({
//             ...r,
//             value: undefined,
//             liveImages: [],
//           }))
//         );
//       }
//     } catch {
//       messageApi.open({
//         type: "error",
//         content: "Error saving execution",
//       });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const onSelectTemplate = (value) => {
//     setSelectedChecklist(value); // ✅ capture checklistId
//     const selected = executions.find((exec) => exec.id === value);

//     const normalized = (selected?.records || []).map((r) => ({
//       ...r,
//       key: r.id || Date.now(),
//       liveImages: r.liveImages || [],
//       sampleImages: r.sampleImages || [],
//     }));

//     setRecords(normalized);
//   };

//   const buildTreeData = (nodes) =>
//     nodes.map((node) => {
//       const isLeaf = !node.children || node.children.length === 0;
//       return {
//         title: node.productName,
//         value: node.id,
//         key: node.id,
//         selectable: isLeaf,
//         disabled: !isLeaf,
//         children: node.children ? buildTreeData(node.children) : [],
//       };
//     });

//   useEffect(() => {
//     (async () => {
//       setIsLoading(true);
//       try {
//         const res = await fetchProduct();
//         setProduct(buildTreeData(res.data));

//         if (editData) {
//           form.setFieldsValue({ serialNumber: editData.serialNumber });
//           getChickListByProductId(editData.productId, editData.checklistId);

//           // also load existing execution record rows (observations, images, etc.)
//           const initialRecords = (
//             editData.checkListExecutionRecordList || []
//           ).map((r) => ({
//             ...r,
//             key: r.id || Date.now(),
//             liveImages: r.liveImages || [],
//             sampleImages: r.sampleImages || [],
//           }));
//           setRecords(initialRecords);
//         } else {
//           form.resetFields();
//           setRecords([]);
//         }
//       } catch (err) {
//         message.error("Network error while fetching products");
//       } finally {
//         setIsLoading(false);
//       }
//       setIsLoading(true);
//       try {
//         const res = await fetchCategoryForFilter();
//         setCategories(res.data);
//       } catch (err) {
//         message.error("Network error while fetching categories");
//       } finally {
//         setIsLoading(false);
//       }
//     })();
//   }, [editData, form]);

//   useEffect(() => {
//     if (id) {
//       // Fetch existing data for editing
//       const fetchData = async () => {
//         const res = await fetchExecutionById(id);
//         setEditData(res.data);
//       };
//       fetchData();
//     }
//   }, [id]);

//   const getFileName = (type) => {
//     const checklistName =
//       executions.find((exec) => exec.id === selectedChecklist)?.checklistName ||
//       "Checklist";
//     const timestamp = new Date()
//       .toISOString()
//       .slice(0, 19)
//       .replace(/[:T]/g, "-");
//     return `${checklistName}_${timestamp}.${type}`;
//   };

//   return (
//     <Spin spinning={isLoading}>
//       <h1>Checklist Execution</h1>
//       {contextHolder}
//       <br />
//       <Row gutter={16}>
//         <Col span={6}>
//           <TreeSelect
//             value={selectedProduct}
//             disabled={mode === "view"}
//             treeData={product}
//             placeholder="Select Product"
//             style={{ width: "100%" }}
//             treeDefaultExpandAll={false}
//             onChange={(value) => getChickListByProductId(value)}
//           />
//         </Col>
//         {executions.length > 0 && (
//           <Col span={6}>
//             <Select
//               value={selectedChecklist}
//               placeholder="Select Checklist"
//               disabled={mode === "view"}
//               style={{ width: "100%" }}
//               options={executions.map((exec) => ({
//                 label: exec.checklistName,
//                 value: exec.id,
//               }))}
//               onChange={onSelectTemplate}
//             />
//           </Col>
//         )}
//         {mode === "view" && (
//           <Col span={6}>
//             <Button
//               style={{ marginRight: "1rem" }}
//               onClick={() =>
//                 exportToPDF(records, categories, getFileName("pdf"))
//               }
//             >
//               Download PDF
//             </Button>
//             <Button
//               onClick={() =>
//                 exportToExcel(records, categories, getFileName("xlsx"))
//               }
//             >
//               Download Excel
//             </Button>
//           </Col>
//         )}
//       </Row>
//       <br />
//       <Form form={form} layout="vertical" onFinish={onFinish}>
//         <Form.Item
//           name="serialNumber"
//           label="Serial Number"
//           rules={[{ required: true, message: "Please input serial number!" }]}
//         >
//           <Input disabled={mode === "view"} />
//         </Form.Item>

//         <Table
//           rowKey="key"
//           scroll={{ x: "max-content" }}
//           columns={columns}
//           disabled={mode === "view"}
//           dataSource={records} // ✅ use state, not template
//           pagination={false}
//         />

//         <Form.Item
//           style={{
//             marginTop: 20,
//             textAlign: "right",
//           }}
//         >
//           <Button
//             style={{ marginRight: "1rem" }}
//             onClick={() => {
//               navigate({ pathname: "/check-list" });
//             }}
//           >
//             Cancel
//           </Button>
//           {mode === "view" || (
//             <Button type="primary" htmlType="submit">
//               Submit
//             </Button>
//           )}
//         </Form.Item>
//       </Form>
//       <Modal
//         title="Image Preview"
//         closable={{ "aria-label": "Custom Close Button" }}
//         open={isModalOpen}
//         onCancel={handleCancel}
//         footer={false}
//       >
//         <img src={selectedImage} alt="Selected" style={{ width: "100%" }} />
//       </Modal>
//       <Modal
//         open={isPreviewOpen}
//         footer={null}
//         onCancel={() => setIsPreviewOpen(false)}
//       >
//         <img
//           src={previewImages[0]}
//           alt="preview"
//           style={{ width: "100%", borderRadius: 8 }}
//         />
//       </Modal>

//       <Modal
//         open={isCamOpen}
//         onCancel={() => {
//           setIsCamOpen(false);

//           // ✅ Stop camera stream when modal is closed
//           if (webcamRef.current && webcamRef.current.stream) {
//             webcamRef.current.stream
//               .getTracks()
//               .forEach((track) => track.stop());
//           }
//         }}
//         footer={[
//           <Button key="capture" type="primary" onClick={capture}>
//             <CameraOutlined />
//           </Button>,
//         ]}
//         destroyOnClose // ✅ ensures Webcam unmounts & remounts fresh
//       >
//         <Webcam
//           audio={false}
//           ref={webcamRef}
//           screenshotFormat="image/png"
//           width="100%"
//           videoConstraints={{ facingMode: "environment" }}
//         />
//       </Modal>
//     </Spin>
//   );
// };

// export default ChecklistExecutionForm;

import {
  Button,
  Form,
  Input,
  Table,
  Select,
  message,
  Row,
  Col,
  Spin,
  TreeSelect,
  Modal,
} from "antd";
import { useEffect, useRef, useState } from "react";
import {
  fetchExecutionById,
  postExecution,
  putExecution,
} from "../service/checklistExecution";
import { InputNumber, Checkbox, Radio } from "antd";
import { fetchBuildersByProductId } from "../../Configuration/ChecklistConfiguration/Service/checklistBuilder";
import { useNavigate, useParams } from "react-router-dom";
import { fetchCategoryForFilter } from "../../Configuration/Category/Service/category";
import Webcam from "react-webcam";
import { CameraOutlined } from "@ant-design/icons";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { fetchProduct } from "../../../../configuration/module/Product/Service/product";

const exportToPDF = (
  records,
  categories,
  productName,
  checklistName,
  serialNumber,
  createdAt,
  updatedAt,
  fileName
) => {
  const doc = new jsPDF();
  const startY = 10;
  const lineHeight = 7;

  // 1️⃣ Metadata table
  autoTable(doc, {
    startY: startY,
    theme: "grid",
    head: [],
    body: [
      ["Product", productName],
      ["Checklist", checklistName],
      ["Serial Number", serialNumber],
      ["Executed At", new Date(createdAt).toLocaleString()],
      ["Updated At", new Date(updatedAt).toLocaleString()],
    ],
    styles: { fontSize: 11, cellPadding: 3 },
    headStyles: { fillColor: [220, 220, 220], fontStyle: "bold" },
  });

  // 2️⃣ Main checklist table
  const tableStartY = doc.lastAutoTable.finalY + 10; // space after metadata table
  const tableData = records.map((r) => {
    const category =
      categories.find((cat) => cat.id === r.categoryId)?.category ||
      r.categoryId;
    const observation =
      r.inputType === "OK_NOT_OK"
        ? r.value === true
          ? "OK"
          : r.value === false
          ? "NOT OK"
          : "-"
        : r.value?.toString() || "-";
    return {
      category,
      description: r.description,
      observation,
      record: r,
    };
  });

  // autoTable(doc, {
  //   startY: tableStartY,
  //   head: [["Category", "Description", "Observation", "Live Images"]],
  //   body: tableData.map((row) => [
  //     row.category,
  //     row.description,
  //     row.observation,
  //     "", // placeholder for images
  //   ]),
  //   styles: { cellPadding: 3, fontSize: 10, valign: "middle" },
  //   columnStyles: { 3: { cellWidth: 60 } },
  //   rowPageBreak: "avoid",
  //   didDrawCell: function (data) {
  //     if (data.section === "body" && data.column.index === 3) {
  //       const rec = tableData[data.row.index]?.record;
  //       if (rec?.liveImages?.length) {
  //         let y = data.cell.y + 2;
  //         const x = data.cell.x + 2;
  //         const imgWidth = Math.max(10, data.cell.width - 4);
  //         rec.liveImages.forEach((imgBase64) => {
  //           const imgSrc = imgBase64.startsWith("data:image")
  //             ? imgBase64
  //             : `data:image/png;base64,${imgBase64}`;
  //           doc.addImage(imgSrc, "PNG", x, y, imgWidth, 30);
  //           y += 32;
  //         });
  //       }
  //     }
  //   },
  // });

  autoTable(doc, {
    startY: tableStartY,
    head: [["Category", "Description", "Observation", "Live Images"]],
    body: tableData.map((row) => [
      row.category,
      row.description,
      row.observation,
      "", // placeholder for images
    ]),
    styles: { fontSize: 10, cellPadding: 3, valign: "middle" },
    headStyles: {
      fillColor: [220, 220, 220],
      fontStyle: "bold",
      minCellHeight: 0, // ✅ important
      valign: "middle", // optional
    },
    columnStyles: { 3: { cellWidth: 60 } },
    rowPageBreak: "avoid",
    didParseCell: function (data) {
      if (data.section === "body" && data.column.index === 3) {
        const rec = tableData[data.row.index]?.record;
        if (rec?.liveImages?.length) {
          const totalHeight = rec.liveImages.length * 32;
          if (totalHeight > data.cell.height) {
            data.cell.styles.minCellHeight = totalHeight;
          }
        }
      }
    },
    didDrawCell: function (data) {
      if (data.section === "body" && data.column.index === 3) {
        const rec = tableData[data.row.index]?.record;
        if (rec?.liveImages?.length) {
          let y = data.cell.y + 2;
          const x = data.cell.x + 2;
          const imgWidth = Math.max(10, data.cell.width - 4);
          rec.liveImages.forEach((imgBase64) => {
            const imgSrc = imgBase64.startsWith("data:image")
              ? imgBase64
              : `data:image/png;base64,${imgBase64}`;
            doc.addImage(imgSrc, "PNG", x, y, imgWidth, 30);
            y += 32;
          });
        }
      }
    },
  });

  doc.save(fileName || "Checklist_Execution.pdf");
};

const exportToExcel = async (
  records,
  categories,
  productName,
  checklistName,
  serialNumber,
  createdAt,
  updatedAt,
  fileName
) => {
  const SCALE_W = 1.25; // +25% width
  const SCALE_H = 1.25 * 1.2; // +25% then +20% height

  const BASE_IMG_W = 100;
  const BASE_IMG_H = 60;
  const BASE_ROW_H = 45;

  const IMG_W = Math.round(BASE_IMG_W * SCALE_W); // 125
  const IMG_H = Math.round(BASE_IMG_H * SCALE_H); // 90
  const ROW_H = Math.round(BASE_ROW_H * SCALE_H); // 68

  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Checklist");

  // 1️⃣ Add metadata rows at the top
  sheet.addRow(["Product", productName]);
  sheet.addRow(["Checklist", checklistName]);
  sheet.addRow(["Serial Number", serialNumber]);
  sheet.addRow(["Executed At", new Date(createdAt).toLocaleString()]);
  sheet.addRow(["Last Updated At", new Date(updatedAt).toLocaleString()]);
  sheet.eachRow((row, rowNumber) => {
    const firstCell = row.getCell(1);
    firstCell.font = { bold: true };
  });

  // 2️⃣ Add empty row for spacing
  sheet.addRow([]);

  // 3️⃣ Add table headers
  const headerRow = sheet.addRow([
    "Category",
    "Description",
    "Observation",
    "Live Images",
  ]);
  headerRow.font = { bold: true };
  headerRow.eachCell((cell) => {
    cell.alignment = {
      vertical: "middle",
      horizontal: "center",
      wrapText: true,
    };
  });

  // track max width needed for image column (in Excel column width units)
  let maxImageColWidthUnits = 10;

  // 4️⃣ Add table rows
  for (const record of records) {
    const categoryName =
      categories.find((c) => c.id === record.categoryId)?.category ||
      record.categoryId;
    const obs =
      record.inputType === "OK_NOT_OK"
        ? record.value === true
          ? "OK"
          : record.value === false
          ? "NOT OK"
          : "-"
        : record.value?.toString() || "-";

    const row = sheet.addRow([categoryName, record.description, obs, ""]);
    row.eachCell((cell) => {
      cell.alignment = {
        vertical: "middle",
        horizontal: "center",
        wrapText: true,
      };
    });

    // Add live images (scaled)
    if (record.liveImages?.length) {
      let startRow = row.number;
      for (let i = 0; i < record.liveImages.length; i++) {
        const img = record.liveImages[i];
        const imageId = workbook.addImage({
          base64: img.startsWith("data:image") ? img.split(",")[1] : img,
          extension: "png",
        });

        sheet.addImage(imageId, {
          tl: { col: 3 + 0.2, row: startRow - 1 + i + 0.2 },
          ext: { width: IMG_W, height: IMG_H },
        });

        // row height scaled with image height
        sheet.getRow(startRow + i).height = ROW_H * 1.1;
      }

      // merge text columns for multiple image rows
      if (record.liveImages.length > 1) {
        sheet.mergeCells(
          `A${row.number}:A${row.number + record.liveImages.length - 1}`
        );
        sheet.mergeCells(
          `B${row.number}:B${row.number + record.liveImages.length - 1}`
        );
        sheet.mergeCells(
          `C${row.number}:C${row.number + record.liveImages.length - 1}`
        );
      }

      // compute candidate width for image column
      const candidateUnits = IMG_W / 7; // px → excel col units
      if (candidateUnits > maxImageColWidthUnits) {
        maxImageColWidthUnits = candidateUnits;
      }
    }
  }

  // 5️⃣ Auto-fit column widths for text columns
  sheet.columns.forEach((col, idx) => {
    if (idx === 3) return; // skip image column (D)
    let maxLength = 10;
    col.eachCell({ includeEmpty: true }, (cell) => {
      const columnLength = cell.value ? cell.value.toString().length : 0;
      if (columnLength > maxLength) maxLength = columnLength;
    });
    col.width = maxLength + 2;
  });

  // 6️⃣ Adjust Live Images column width
  const finalImageColWidth = Math.max(
    sheet.getColumn(4).width || 10,
    Math.round(maxImageColWidthUnits + 2)
  );
  sheet.getColumn(4).width = finalImageColWidth;

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), fileName || "Checklist_Execution.xlsx");
};

const ChecklistExecutionForm = ({ mode }) => {
  const { id } = useParams();
  const [form] = Form.useForm();
  const [records, setRecords] = useState([]);
  const [editData, setEditData] = useState(null);
  const [categories, setCategories] = useState([]);
  const [product, setProduct] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [executions, setExecutions] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const navigate = useNavigate();
  const [isCamOpen, setIsCamOpen] = useState(false);
  const [activeRecord, setActiveRecord] = useState(null);
  const [previewImages, setPreviewImages] = useState([]);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedChecklist, setSelectedChecklist] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();

  const webcamRef = useRef(null);

  const capture = () => {
    const imageSrc = webcamRef.current.getScreenshot();

    if (activeRecord) {
      if (!activeRecord.liveImages) {
        activeRecord.liveImages = [];
      }
      activeRecord.liveImages.push(imageSrc);
      setRecords([...records]);
    }

    // ✅ Just close modal (do not stop stream here)
    setIsCamOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
  };

  const getChickListByProductId = async (productId, preselectChecklistId) => {
    setSelectedProduct(productId);
    setIsLoading(true);
    try {
      const res = await fetchBuildersByProductId(productId);
      setExecutions(res.data);

      // ✅ only after executions are ready
      if (preselectChecklistId) {
        setSelectedChecklist(preselectChecklistId);
        const selected = res.data.find(
          (exec) => exec.id === preselectChecklistId
        );
        if (selected) {
          let normalized = (selected.records || []).map((r) => ({
            ...r,
            key: r.id || Date.now(),
            liveImages: r.liveImages || [],
            sampleImages: r.sampleImages || [],
          }));
          const mergeWithObservations = (templateRecords, observations) => {
            return templateRecords.map((r) => {
              const obs = observations.find((o) => o.recordId === r.id);
              return {
                ...r,
                value: obs ? obs.value : r.value,
                liveImages: obs ? obs.liveImages || [] : r.liveImages || [],
              };
            });
          };

          if (editData?.observations) {
            normalized = mergeWithObservations(
              normalized,
              editData.observations
            );
          }

          setRecords(normalized);
        }
      } else {
        setSelectedChecklist(null);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      title: "Category",
      dataIndex: "categoryId",
      key: "categoryId",
      render: (_, record) =>
        categories.find((cat) => cat.id === record.categoryId)?.category,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (_, record) => record.description,
    },
    {
      title: "Observation",
      dataIndex: "response",
      key: "response",
      render: (_, record) => {
        switch (record.inputType) {
          case "OK_NOT_OK":
            return (
              <div style={{ display: "flex", gap: "1rem" }}>
                <Checkbox
                  checked={record.value === true}
                  disabled={mode === "view"}
                  onChange={() => {
                    record.value = true;
                    setRecords([...records]);
                  }}
                >
                  OK
                </Checkbox>
                <Checkbox
                  checked={record.value === false}
                  disabled={mode === "view"}
                  onChange={() => {
                    record.value = false;
                    setRecords([...records]);
                  }}
                >
                  NOT OK
                </Checkbox>
              </div>
            );

          case "OPTIONS":
            return (
              <Radio.Group
                value={record.value}
                disabled={mode === "view"}
                onChange={(e) => {
                  record.value = e.target.value;
                  setRecords([...records]);
                }}
              >
                {record.options?.map((opt, idx) => (
                  <Radio key={idx} value={opt}>
                    {opt}
                  </Radio>
                ))}
              </Radio.Group>
            );

          case "STRING":
            return (
              <Input
                // defaultValue={record.value}
                value={record.value || ""}
                disabled={mode === "view"}
                onChange={(e) => {
                  record.value = e.target.value;
                  setRecords([...records]);
                }}
              />
            );

          case "DOUBLE":
            return (
              <InputNumber
                style={{ width: "100%" }}
                value={record.value}
                disabled={mode === "view"}
                onChange={(val) => {
                  record.value = val;
                  setRecords([...records]);
                }}
              />
            );

          default:
            return <span>-</span>;
        }
      },
    },
    {
      title: "Sample Images",
      dataIndex: "sampleImages",
      key: "sampleImages",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
          {record.sampleImages?.map((img, idx) => {
            const src =
              typeof img === "string"
                ? `data:image/png;base64,${img}` // raw base64 string
                : img.url; // normalized object
            return (
              <img
                key={idx}
                src={src}
                alt={`sample-${idx}`}
                style={{
                  width: 100,
                  height: 100,
                  objectFit: "cover",
                  borderRadius: 4,
                }}
                onClick={() => {
                  setIsModalOpen(true);
                  setSelectedImage(src);
                }}
              />
            );
          })}

          {record.sampleImages.length === 0 && "No image available"}
        </div>
      ),
    },
    {
      title: "Live Images",
      dataIndex: "liveImages",
      key: "liveImages",
      render: (_, record) => (
        <div>
          <div
            style={{
              display: "flex",
              gap: "8px",
              marginTop: 8,
              flexWrap: "wrap",
            }}
          >
            {record.liveImages?.map((img, idx) => (
              <div
                key={idx}
                style={{ position: "relative", display: "inline-block" }}
              >
                <img
                  src={img}
                  alt="captured"
                  style={{
                    width: 100,
                    height: 100,
                    objectFit: "cover",
                    borderRadius: 4,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    // preview image in modal
                    setPreviewImages([img]);
                    setIsPreviewOpen(true);
                  }}
                />

                {mode === "view" || (
                  <Button
                    type="text"
                    size="small"
                    danger
                    style={{
                      position: "absolute",
                      top: -6,
                      right: -6,
                      borderRadius: "50%",
                      background: "white",
                      border: "1px solid #ccc",
                      lineHeight: "12px",
                      height: 18,
                      width: 18,
                      padding: 0,
                      fontSize: 10,
                    }}
                    onClick={() => {
                      record.liveImages = record.liveImages.filter(
                        (_, i) => i !== idx
                      );
                      setRecords([...records]);
                    }}
                  >
                    ✕
                  </Button>
                )}
              </div>
            ))}
            {record.liveImages.length === 0 && "No image available"}
          </div>
          {mode === "view" || (
            <Button
              size="small"
              onClick={() => {
                setActiveRecord(record);
                setIsCamOpen(true);
              }}
            >
              <CameraOutlined />
            </Button>
          )}
        </div>
      ),
    },
  ];

  const onFinish = (values) => {
    const payload = {
      serialNumber: values.serialNumber, // unique id
      productId: selectedProduct,
      checklistId: selectedChecklist,
      observations: records.map((r) => ({
        recordId: r.id || null, // optional: link to checklist record
        inputType: r.inputType, // send type for backend parsing
        value: r.value, // actual observation
        liveImages: r.liveImages || [],
      })),
    };

    saveData(payload);
  };

  const saveData = async (data) => {
    setIsLoading(true);
    try {
      let res;
      if (editData) res = await putExecution(data, editData.id);
      else res = await postExecution(data);
      messageApi.open({
        type: "success",
        content: `Execution ${editData ? "updated" : "added"} successfully`,
      });

      if (editData) {
        setTimeout(() => {
          navigate({ pathname: "/check-list" });
        }, 2000);
      } else {
        form.resetFields(["serialNumber"]);
        setRecords((prev) =>
          prev.map((r) => ({
            ...r,
            value: undefined,
            liveImages: [],
          }))
        );
      }
    } catch {
      messageApi.open({
        type: "error",
        content: "Error saving execution",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const onSelectTemplate = (value) => {
    setSelectedChecklist(value); // ✅ capture checklistId
    const selected = executions.find((exec) => exec.id === value);

    const normalized = (selected?.records || []).map((r) => ({
      ...r,
      key: r.id || Date.now(),
      liveImages: r.liveImages || [],
      sampleImages: r.sampleImages || [],
    }));

    setRecords(normalized);
  };

  const buildTreeData = (nodes) =>
    nodes.map((node) => {
      const isLeaf = !node.children || node.children.length === 0;
      return {
        title: node.productName,
        value: node.id,
        key: node.id,
        selectable: isLeaf,
        disabled: !isLeaf,
        children: node.children ? buildTreeData(node.children) : [],
      };
    });

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        const res = await fetchProduct();
        setProduct(buildTreeData(res.data));

        if (editData) {
          form.setFieldsValue({ serialNumber: editData.serialNumber });
          getChickListByProductId(editData.productId, editData.checklistId);

          // also load existing execution record rows (observations, images, etc.)
          const initialRecords = (
            editData.checkListExecutionRecordList || []
          ).map((r) => ({
            ...r,
            key: r.id || Date.now(),
            liveImages: r.liveImages || [],
            sampleImages: r.sampleImages || [],
          }));
          setRecords(initialRecords);
        } else {
          form.resetFields();
          setRecords([]);
        }
      } catch (err) {
        message.error("Network error while fetching products");
      } finally {
        setIsLoading(false);
      }
      setIsLoading(true);
      try {
        const res = await fetchCategoryForFilter();
        setCategories(res.data);
      } catch (err) {
        message.error("Network error while fetching categories");
      } finally {
        setIsLoading(false);
      }
    })();
  }, [editData, form]);

  useEffect(() => {
    if (id) {
      // Fetch existing data for editing
      const fetchData = async () => {
        const res = await fetchExecutionById(id);
        setEditData(res.data);
      };
      fetchData();
    }
  }, [id]);

  const getFileName = (type) => {
    const checklistName =
      executions.find((exec) => exec.id === selectedChecklist)?.checklistName ||
      "Checklist";
    const timestamp = new Date()
      .toISOString()
      .slice(0, 19)
      .replace(/[:T]/g, "-");
    return `${checklistName}_${timestamp}.${type}`;
  };

  console.log("product", product, selectedProduct);

  // const productName =
  //   product.find((p) => p.value === selectedProduct)?.title || "";
  function findTitleByValue(tree, value) {
    for (const node of tree) {
      if (node.value === value) return node.title;
      if (node.children) {
        const childResult = findTitleByValue(node.children, value);
        if (childResult) return childResult;
      }
    }
    return "";
  }

  const productName = findTitleByValue(product, selectedProduct);

  const checklistName =
    executions.find((e) => e.id === selectedChecklist)?.checklistName || "";
  const serialNumber = form.getFieldValue("serialNumber") || "";
  const createdAt = editData?.createdAt || new Date();
  const updatedAt = editData?.updatedAt || new Date();

  return (
    <Spin spinning={isLoading}>
      <div style={{ fontSize: "1rem", fontWeight: 700 }}>
        Checklist Execution
      </div>
      {contextHolder}
      <br />
      <Row gutter={[16, 16]}>
        <Col>
          <TreeSelect
            value={selectedProduct}
            disabled={mode === "view"}
            treeData={product}
            placeholder="Select Product"
            style={{ width: "100%", minWidth: 240 }}
            treeDefaultExpandAll={false}
            onChange={(value) => getChickListByProductId(value)}
          />
        </Col>
        {executions.length > 0 && (
          <Col>
            <Select
              value={selectedChecklist}
              placeholder="Select Checklist"
              disabled={mode === "view"}
              style={{ width: "100%", minWidth: 240 }}
              options={executions.map((exec) => ({
                label: exec.checklistName,
                value: exec.id,
              }))}
              onChange={onSelectTemplate}
            />
          </Col>
        )}
        {mode === "view" && (
          <Col>
            <Button
              style={{ marginRight: "1rem" }}
              onClick={() =>
                // exportToPDF(records, categories, getFileName("pdf"))
                exportToPDF(
                  records,
                  categories,
                  productName,
                  checklistName,
                  serialNumber,
                  createdAt,
                  updatedAt,
                  getFileName("pdf")
                )
              }
            >
              Download PDF
            </Button>
            <Button
              onClick={() =>
                // exportToExcel(records, categories, getFileName("xlsx"))
                exportToExcel(
                  records,
                  categories,
                  productName,
                  checklistName,
                  serialNumber,
                  createdAt,
                  updatedAt,
                  getFileName("xlsx")
                )
              }
            >
              Download Excel
            </Button>
          </Col>
        )}
      </Row>
      <br />
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="serialNumber"
          label="Serial Number"
          rules={[{ required: true, message: "Please input serial number!" }]}
        >
          <Input disabled={mode === "view"} />
        </Form.Item>

        <Table
          rowKey="key"
          scroll={{ x: "max-content" }}
          columns={columns}
          disabled={mode === "view"}
          dataSource={records} // ✅ use state, not template
          pagination={false}
        />

        <Form.Item
          style={{
            marginTop: 20,
            textAlign: "right",
          }}
        >
          <Button
            style={{ marginRight: "1rem" }}
            onClick={() => {
              navigate({ pathname: "/check-list-builder/check-list" });
            }}
          >
            Cancel
          </Button>
          {mode === "view" || (
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          )}
        </Form.Item>
      </Form>
      <Modal
        title="Image Preview"
        closable={{ "aria-label": "Custom Close Button" }}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={false}
      >
        <img src={selectedImage} alt="Selected" style={{ width: "100%" }} />
      </Modal>
      <Modal
        open={isPreviewOpen}
        footer={null}
        onCancel={() => setIsPreviewOpen(false)}
      >
        <img
          src={previewImages[0]}
          alt="preview"
          style={{ width: "100%", borderRadius: 8 }}
        />
      </Modal>

      <Modal
        open={isCamOpen}
        onCancel={() => {
          setIsCamOpen(false);

          // ✅ Stop camera stream when modal is closed
          if (webcamRef.current && webcamRef.current.stream) {
            webcamRef.current.stream
              .getTracks()
              .forEach((track) => track.stop());
          }
        }}
        footer={[
          <Button key="capture" type="primary" onClick={capture}>
            <CameraOutlined />
          </Button>,
        ]}
        destroyOnClose // ✅ ensures Webcam unmounts & remounts fresh
      >
        <Webcam
          audio={false}
          ref={webcamRef}
          screenshotFormat="image/png"
          width="100%"
          videoConstraints={{ facingMode: "environment" }}
        />
      </Modal>
    </Spin>
  );
};

export default ChecklistExecutionForm;
